<template>
  <study-layout>
    <template #header>
      <div class="header-menu-item">
        <div class="header-menu-item" @click="goBackHome">返回官网</div>
      </div>
    </template>
    <template #default>
      <div class="login-content">
        <div class="title">
          <span class="login-txt">登录</span>
          <span class="tips">请使用标准日本语（日语教材）账号登录</span>
        </div>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="80px"
          class="login-form"
        >
          <el-form-item prop="userName">
            <template #label>
              <span>账</span>
              <span style="margin-left: 1em">号</span>
            </template>
            <el-input
              v-model.trim="form.userName"
              placeholder="请输入手机号或邮箱"
              @keyup.enter.native="subLogin"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <template #label>
              <span>密</span>
              <span style="margin-left: 1em">码</span>
            </template>
            <el-input
              type="password"
              v-model.trim="form.password"
              :visibilityToggle="false"
              placeholder="请输入密码"
              @keyup.enter.native="subLogin"
            ></el-input>
          </el-form-item>
          <div class="yzm-wrap">
            <el-form-item label="验证码" prop="code">
              <el-input
                v-model.trim="form.code"
                placeholder="请输入验证码"
                :maxLength="4"
                @keyup.enter.native="subLogin"
              ></el-input>
            </el-form-item>
            <div class="code_canvas" @click="getCode">
              <div v-if="codeLoading" class="code-loading">
                <i class="el-icon-loading"></i>
                <span>加载中...</span>
              </div>
              <img v-else :src="codeImg" alt="验证码" />
            </div>
          </div>

          <div class="public-btn" @click="subLogin">登录</div>
        </el-form>
      </div>
    </template>
  </study-layout>
</template>

<script>
import { StudyLayout } from "@/components/Layouts/index";
import { loginDB, showCodeDB } from "@/interface";
import { check_browser } from "@/utils";

import FingerprintJS from "@fingerprintjs/fingerprintjs";
export default {
  name: "Login",
  components: {
    StudyLayout,
  },
  data() {
    return {
      form: {},

      rules: {
        userName: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },

      codeImg: "",
      fingerprint: Math.floor(Math.random() * 1000) + "" + new Date().getTime(),

      randomNum: "",
      codeLoading: false, // 新增验证码加载状态
    };
  },
  computed: {},
  created() {
    this.getCode();
  },
  mounted() {
    this.getFingerprint();
  },
  methods: {
    goBackHome() {
      const bro = check_browser();
      if (bro == "pc") {
        this.$router.push("/main");
      } else {
        // this.$router.push("/mobile");
        this.$router.push("/main/home");
      }
    },
    getCode() {
      this.codeLoading = true; // 开始加载
      const randomNum = new Date().getTime() + "";
      this.randomNum = randomNum;
      showCodeDB({ random: randomNum })
        .then((res) => {
          const data = this.$aes128Decrypt(res.data);
          this.codeImg = data;
          console.log("验证码获取成功:", data); // 添加调试信息
        })
        .catch((error) => {
          console.error("验证码获取失败:", error); // 添加错误处理
          // 如果获取失败，可以显示一个默认的验证码图片或错误提示
          this.$message.error("验证码获取失败，请点击重试");
        })
        .finally(() => {
          this.codeLoading = false; // 结束加载
        });
    },

    subLogin() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const param = {
            user_name: this.form.userName,
            password: this.form.password,
            device_id: this.fingerprint,
            inputCode: this.form.code,
            random: this.randomNum,
          };
          loginDB(param)
            .then((res) => {
              const data = this.$aes128Decrypt(res.data);
              localStorage.setItem("rypc_userInfo", JSON.stringify(data));
              localStorage.setItem("rypc_token", data.token);
              this.$router.replace({ path: "/gaokao" });
            })
            .catch(() => {
              this.getCode();
            });
        }
      });
    },

    async getFingerprint() {
      const fp = await FingerprintJS.load();
      const options = {
        excludes: {
          // 排除以下因素，根据需要可以添加更多
          userAgent: true, // 排除User-Agent
          language: true, // 排除语言信息
          colorDepth: true, // 排除颜色深度
          pixelRatio: true, // 排除像素比
          screenResolution: true, // 排除屏幕分辨率
          availableScreenResolution: true, // 排除可用屏幕分辨率
          plugins: true, // 排除插件信息
          canvas: true, // 排除canvas指纹信息
          webgl: true, // 排除WebGL指纹信息
          audio: true, // 排除音频指纹信息
          vibrate: true, // 排除震动指纹信息
          touchSupport: true, // 排除触摸支持信息
          indexedDb: true, // 排除IndexedDB指纹信息
          addBehavior: true, // 排除addBehavior指纹信息
          openDatabase: true, // 排除openDatabase指纹信息
          cpuClass: true, // 排除CPU类指纹信息
        },
      };

      const result = await fp.get(options);
      console.log(result.visitorId); // 打印指纹信息
      this.fingerprint = result.visitorId;
    },
  },
};
</script>

<style lang="scss" scoped>
.login-content {
  width: 1002px;
  height: 536px;
  margin: 0 auto;
  background: white;
  padding: 10px;

  & > .title {
    width: 580px;
    overflow: hidden;
    margin: 40px auto;
    span {
      color: #078710;
      float: left;
      line-height: 30px;
    }

    .login-txt {
      font-size: 26px;
    }

    .tips {
      font-size: 14px;
      margin-left: 40px;
      font-weight: 700;
    }
  }

  & > .login-form {
    width: 540px;
    margin: 0 auto;

    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 20px;

        .el-form-item__label {
          font-size: 14px;
          line-height: 38px;
        }

        .el-input {
          .el-input__inner {
            height: 38px;
            line-height: 38px;
            font-size: 14px;
          }
        }
      }
    }
  }

  .yzm-wrap {
    position: relative;
    ::v-deep .el-form-item {
      padding-right: 120px; // 增加右侧padding，为验证码留出更多空间
    }
    .code_canvas {
      position: absolute;
      right: 0;
      top: 1px;
      height: 38px;
      width: 100px; // 增加宽度，确保验证码完整显示
      cursor: pointer; // 添加手型光标
      border: 1px solid #dcdfe6; // 添加边框，提升视觉效果
      border-radius: 4px; // 添加圆角
      overflow: hidden; // 防止内容溢出
      position: relative; // 为内部元素定位
      flex-shrink: 0; // 防止被压缩
      white-space: nowrap; // 防止换行

      // 加载状态样式
      .code-loading {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        color: #909399;
        font-size: 12px;

        i {
          font-size: 16px;
          margin-bottom: 2px;
        }

        span {
          font-size: 10px;
        }
      }

      // 刷新提示
      .code-refresh-tip {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.6);
        color: white;
        font-size: 10px;
        text-align: center;
        padding: 2px 0;
        opacity: 0;
        transition: opacity 0.3s ease;
      }

      img {
        height: 38px;
        width: 100px; // 增加图片宽度
        object-fit: contain; // 改为contain，确保图片完整显示
        display: block; // 确保图片正确显示
        flex-shrink: 0; // 防止图片被压缩
      }

      // 添加悬停效果
      &:hover {
        .code-refresh-tip {
          opacity: 1; // 悬停时显示提示
        }
      }

      // 点击效果
      &:active {
        transform: scale(0.98);
      }
    }
  }
  .public-btn {
    margin: 0 auto;
  }
}

// PC端样式优化（确保验证码不换行）
@media (min-width: 1025px) {
  .login-content {
    .yzm-wrap {
      ::v-deep .el-form-item {
        padding-right: 120px !important;
        white-space: nowrap !important;
        overflow: hidden !important;
      }

      .code_canvas {
        position: absolute !important;
        right: 0 !important;
        top: 1px !important;
        height: 38px !important;
        width: 100px !important;
        flex-shrink: 0 !important;
        white-space: nowrap !important;
        overflow: hidden !important;

        img {
          height: 38px !important;
          width: 100px !important;
          object-fit: contain !important;
          display: block !important;
          flex-shrink: 0 !important;
        }
      }
    }
  }
}

// 移动端响应式样式
@media (max-width: 1024px) {
  .login-content {
    width: 100% !important;
    height: auto !important;
    margin: 0 !important;
    padding: 20px !important;
    min-height: calc(100vh - 200px);

    & > .title {
      width: 100% !important;
      margin: 20px auto !important;
      text-align: center !important;

      span {
        float: none !important;
        display: block !important;
        margin: 5px 0 !important;
      }

      .login-txt {
        font-size: 32px !important;
        margin-bottom: 10px !important;
      }

      .tips {
        font-size: 18px !important;
        margin-left: 0 !important;
        margin-top: 10px !important;
      }
    }

    & > .login-form {
      width: 100% !important;
      max-width: 500px !important;
      margin: 0 auto !important;
    }

    // 移动端表单优化
    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 20px !important;

        .el-form-item__label {
          font-size: 16px !important;
          line-height: 44px !important;
        }

        .el-input {
          .el-input__inner {
            height: 44px !important;
            line-height: 44px !important;
            font-size: 16px !important;
          }
        }
      }
    }

    .yzm-wrap {
      ::v-deep .el-form-item {
        padding-right: 120px !important; // 增加右侧padding
      }

      .code_canvas {
        height: 44px !important;
        width: 110px !important; // 增加移动端验证码宽度

        .code-loading {
          font-size: 14px !important;

          i {
            font-size: 18px !important;
          }

          span {
            font-size: 12px !important;
          }
        }

        .code-refresh-tip {
          font-size: 11px !important;
          padding: 3px 0 !important;
        }

        img {
          height: 44px !important;
          width: 110px !important; // 增加移动端图片宽度
          object-fit: contain !important; // 确保图片完整显示
        }
      }
    }

    .public-btn {
      width: 100% !important;
      height: 50px !important;
      line-height: 50px !important;
      font-size: 18px !important;
      margin-top: 20px !important;
    }
  }
}

// 小屏幕设备优化
@media (max-width: 768px) {
  .login-content {
    padding: 15px !important;

    & > .title {
      margin: 15px auto !important;

      .login-txt {
        font-size: 28px !important;
      }

      .tips {
        font-size: 16px !important;
      }
    }

    & > .login-form {
      max-width: 100% !important;
    }

    // 移动端表单进一步优化
    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 15px !important;

        .el-form-item__label {
          font-size: 15px !important;
        }

        .el-input {
          .el-input__inner {
            height: 50px !important;
            line-height: 50px !important;
            font-size: 16px !important;
          }
        }
      }
    }

    .yzm-wrap {
      .code_canvas {
        height: 50px !important;
        width: 120px !important; // 增加小屏幕验证码宽度

        .code-loading {
          font-size: 15px !important;

          i {
            font-size: 20px !important;
          }

          span {
            font-size: 13px !important;
          }
        }

        .code-refresh-tip {
          font-size: 12px !important;
          padding: 4px 0 !important;
        }

        img {
          height: 50px !important;
          width: 120px !important; // 增加小屏幕图片宽度
          object-fit: contain !important; // 确保图片完整显示
        }
      }
    }

    .public-btn {
      height: 50px !important;
      line-height: 50px !important;
      font-size: 18px !important;
    }
  }
}

// 超小屏幕优化
@media (max-width: 480px) {
  .login-content {
    padding: 10px !important;

    & > .title {
      margin: 10px auto !important;

      .login-txt {
        font-size: 24px !important;
      }

      .tips {
        font-size: 14px !important;
      }
    }

    // 超小屏幕表单优化
    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 12px !important;

        .el-form-item__label {
          font-size: 14px !important;
          line-height: 50px !important;
        }

        .el-input {
          .el-input__inner {
            height: 50px !important;
            line-height: 50px !important;
            font-size: 15px !important;
          }
        }
      }
    }

    .yzm-wrap {
      .code_canvas {
        height: 50px !important;
        width: 120px !important; // 增加超小屏幕验证码宽度

        .code-loading {
          font-size: 14px !important;

          i {
            font-size: 18px !important;
          }

          span {
            font-size: 12px !important;
          }
        }

        .code-refresh-tip {
          font-size: 11px !important;
          padding: 3px 0 !important;
        }

        img {
          height: 50px !important;
          width: 120px !important; // 增加超小屏幕图片宽度
          object-fit: contain !important; // 确保图片完整显示
        }
      }
    }

    .public-btn {
      height: 50px !important;
      line-height: 50px !important;
      font-size: 16px !important;
    }
  }
}

// 触摸设备优化
@media (hover: none) and (pointer: coarse) {
  .login-content {
    .public-btn {
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);

      &:active {
        transform: scale(0.98);
      }
    }

    .code_canvas {
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);

      &:active {
        transform: scale(0.95);
      }
    }
  }
}
</style>
